import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSliders,
  faShareNodes,
  faPaintBrush,
  faRulerCombined,
  faSearchPlus,
  faHeadphones,
  faFaceSmile,
} from "@fortawesome/free-solid-svg-icons";

const TrendlineIcon = ({ className = "w-[18px] h-[18px]" }) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="5" y1="15" x2="15" y2="5" />
    <circle cx="5" cy="15" r="1.8" fill="#ffffff" />
    <circle cx="15" cy="5" r="1.8" fill="#ffffff" />
  </svg>
);

const ToolButton = ({ icon, label, onClick, active, children, idAttr }) => (
  <button
    type="button"
    onClick={onClick}
    title={label}
    id={idAttr}
    className={`w-10 h-10 flex items-center justify-center rounded hover:bg-gray-100 ${
      active ? "bg-yellow-100 text-gray-800" : "text-gray-600"
    }`}
  >
    {children || <FontAwesomeIcon icon={icon} />}
  </button>
);

const TOOLS = [
  { key: "trendline", label: "Trendline / Draw", idAttr: "chart-guide-drawing-tools" },
  { key: "settings", label: "Settings", icon: faSliders },
  { key: "pattern", label: "Pattern", icon: faShareNodes },
  { key: "adjust", label: "Adjust", icon: faSliders },
  { key: "brush", label: "Brush", icon: faPaintBrush },
  { key: "text", label: "Text" },
  { key: "emoji", label: "Emoji", icon: faFaceSmile },
  { key: "ruler", label: "Ruler", icon: faRulerCombined },
  { key: "zoom", label: "Zoom", icon: faSearchPlus },
  { key: "audio", label: "Audio", icon: faHeadphones },
];

const LAUNCH_VISIBLE_TOOLS = new Set(["trendline"]);
const ChartLeftToolbar = ({ onPencil, drawActive }) => {
  const noop = () => {};
  return (
    <div className="flex flex-col items-center gap-1 py-2 border-r border-gray-200 bg-white w-10">
      {TOOLS.filter((tool) => LAUNCH_VISIBLE_TOOLS.has(tool.key)).map((tool) => {
        const isTrendline = tool.key === "trendline";
        return (
          <ToolButton
            key={tool.key}
            icon={tool.icon}
            label={tool.label}
            idAttr={tool.idAttr}
            onClick={isTrendline ? onPencil : noop}
            active={isTrendline ? !!drawActive : false}
          >
            {isTrendline ? (
              <TrendlineIcon />
            ) : tool.key === "text" ? (
              <span className="text-base font-bold">T</span>
            ) : null}
          </ToolButton>
        );
      })}
    </div>
  );
};

export default ChartLeftToolbar;
